import { Patient } from '@/modules/surgicalEvent';
import { useAppDispatch } from '@/hooks';
import { ProtocolName, useProtocolQuery } from '@/modules/protocol';
import { ExtraActions } from '@/components/protocolStatusActionButton';
import { useMemo } from 'react';
import { openProtocolDrawer } from '@/modules/appContext';

export const useCardiacStressTestExtraActions = ({
  patient,
  hasReferrals: extHasReferrals
}: {
  patient: Patient;
  hasReferrals?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const { currentData: protocol } = useProtocolQuery(
    {
      patientId: patient.id,
      protocolName: ProtocolName.CARDIAC_STRESS_TEST
    },
    {
      skip: extHasReferrals !== undefined
    }
  );

  const hasReferrals = extHasReferrals ?? !!protocol?.items?.length;

  return useMemo(() => {
    const action: ExtraActions = [
      {
        key: 'viewReferral',
        textId:
          'doctor-dashboard.protocol.status.action.to.VIEW_CARDIAC_STRESS_TEST_REFERRAL',
        variant: 'outlined' as const,
        onClick: () => {
          dispatch(
            openProtocolDrawer({
              type: ProtocolName.CARDIAC_STRESS_TEST,
              data: {
                patient,
                targetStatus: null as any
              }
            })
          );
        }
      }
    ];

    if (hasReferrals) {
      return action;
    }

    return [];
  }, [dispatch, hasReferrals, patient]);
};
